'use strict';

function getUserData(deps) {
	function hasCapability(config, setting, url) {
		if (!config.UserInfo || !config.UserInfo[setting]) return '';

		return '/' + url + '/' + config.UserInfo[setting];
	}
	function getSetting(config, setting) {
		if (!config.UserInfo || !config.UserInfo[setting]) return '';

		return config.UserInfo[setting];
	}

	return {

		getSubscriptionUrl: function() {
			return '/subscription';
		},

		getProfileUrl: function(config) {
			return hasCapability(config, 'user_id', 'profile');
		},

		getCompanyUrl: function(config) {
			return hasCapability(config, 'company_id', 'companies');
		},

		getSettingsUrl: function() {
			return '/settings';
		},

		getMobileSwitchUrl: function() {
			var fn = deps && deps.switchMobileLinkFunction;
			return 'javascript:' + (fn || ''); // eslint-disable-line no-script-url
		},

		getUserEmail: function(config) {
			return getSetting(config, 'email');
		},

		getUserName: function(config) {
			return getSetting(config, 'name');
		},

		getUserFirstName: function(config) {
			return getSetting(config, 'given_name');
		},

		getUserImg: function(config) {
			return config.IMG_BASE + '/profilePics/' + getSetting(config, 'profilePic');
		}
	};
}

module.exports = {
	getUserData: getUserData
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/models/user-urls.js
// module id = 5
// module chunks = 0